// extracted by mini-css-extract-plugin
export default {"root":"ShowAppPage_root__KEqqs","profile":"ShowAppPage_profile__bFQkW","wrapper":"ShowAppPage_wrapper__kl-vC"};